// chartRangeFormatter.js - Utility for formatting chart ranges for display

/**
 * Convert chart range code to human-readable text for sharing.
 * @param {string} range - The chart range code (e.g., '15', 'max').
 * @param {'sessions'|'days'} [mode='sessions'] - Whether `range` counts sessions or calendar days.
 * @returns {string} Human-readable range text
 */
export const formatChartRangeForShare = (range, mode = 'sessions') => {
  if (range === 'max') return 'all time';

  const unit = mode === 'days' ? 'days' : 'sessions';
  return `${range} ${unit}`;
};
